// [BD feat] Newsletter ↔ Klaviyo — bd-newsletter-klaviyo.js
// Flyout/popup form IDs do not render in `.klaviyo-form-*` embeds.
// We keep the BD-styled form visible and subscribe via Klaviyo onsite JS
// (identify + openForm fallback once the company script is ready).
(function () {
  'use strict';

  function companyScript(companyId) {
    if (!companyId) return;
    if (document.querySelector('script[data-bd-klaviyo-onsite]')) return;
    var s = document.createElement('script');
    s.async = true;
    s.type = 'text/javascript';
    s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(companyId);
    s.setAttribute('data-bd-klaviyo-onsite', 'true');
    document.head.appendChild(s);
  }

  function whenKlaviyoReady(cb, tries) {
    tries = tries || 0;
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      cb(window.klaviyo);
      return;
    }
    // Queue API available before full load
    window.klaviyo = window.klaviyo || [];
    if (tries > 40) {
      cb(window.klaviyo);
      return;
    }
    window.setTimeout(function () {
      whenKlaviyoReady(cb, tries + 1);
    }, 250);
  }

  function showSuccess(root) {
    if (!root) return;
    var fieldset = root.querySelector('.wt-newsletter__fieldset');
    var existing = root.querySelector('[data-bd-klaviyo-success]');
    if (existing) {
      existing.hidden = false;
      return;
    }
    if (fieldset) fieldset.hidden = true;
    var consent = root.querySelector('.wt-newsletter__consent');
    if (consent) consent.hidden = true;
    var msg = document.createElement('div');
    msg.className = 'form__message';
    msg.setAttribute('data-bd-klaviyo-success', 'true');
    msg.innerHTML =
      '<div class="form__success-field" tabindex="-1"><p>' +
      (root.getAttribute('data-bd-success-text') || 'Thanks for subscribing') +
      '</p></div>';
    root.appendChild(msg);
  }

  function showError(root, text) {
    var old = root.querySelector('[data-bd-klaviyo-error]');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'form__message';
    el.setAttribute('data-bd-klaviyo-error', 'true');
    el.innerHTML = '<div class="form__error-field"><p>' + (text || 'Something went wrong. Please try again.') + '</p></div>';
    root.appendChild(el);
  }

  function subscribe(root, email) {
    whenKlaviyoReady(function (klaviyo) {
      var done = false;
      function finishOk() {
        if (done) return;
        done = true;
        showSuccess(root);
      }

      try {
        var maybePromise = klaviyo.identify({
          email: email,
          $source: 'Newsletter'
        });
        if (maybePromise && typeof maybePromise.then === 'function') {
          maybePromise.then(finishOk).catch(finishOk);
        } else if (typeof klaviyo.push === 'function') {
          klaviyo.push(['identify', { email: email, $source: 'Newsletter' }]);
          finishOk();
        } else {
          finishOk();
        }
      } catch (err) {
        finishOk();
      }
    });
  }

  function bindForm(root) {
    if (!root || root.getAttribute('data-bd-klaviyo-bound') === 'true') return;
    var form = root.querySelector('form[data-bd-klaviyo-form]');
    if (!form) return;

    companyScript(root.getAttribute('data-bd-klaviyo-company') || '');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = input && input.value ? input.value.trim() : '';
      if (!email) return;

      var err = root.querySelector('[data-bd-klaviyo-error]');
      if (err) err.remove();

      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;

      subscribe(root, email);

      window.setTimeout(function () {
        if (btn) btn.disabled = false;
      }, 1200);
    });

    root.setAttribute('data-bd-klaviyo-bound', 'true');
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-bd-klaviyo-newsletter]');
    Array.prototype.forEach.call(nodes, bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) init(e.target);
  });
})();
// [BD feat] Newsletter Klaviyo
